$(document).on('fetchedPrice', (event, itemId, node) => {
  if ($(`[data-price-uvp-target="${itemId}"]`).length) {
    $(`[data-price-uvp-target="${itemId}"]`).get(0).innerHTML = $(node).find('[data-price-uvp]').get(0).innerHTML;
  }
});
